import React from "react";

const FailureRegion = () => {
  return (
    <div className="section section-center">
      <div className="success">
        <div class="xcircle">
          <span className="icon">&#10006;</span>
        </div>
        <div className="spacer">&nbsp;</div>
        <div className="failure-title">Account activation failed</div>
        <div className="success-msg">
          Unable to activate account, please contact support.
        </div>
        <div className="success-msg">
          If you have any questions or need further assistance, please don't
          hesitate to contact our customer support.
        </div>
      </div>
    </div>
  );
};

export default FailureRegion;
